import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudentDetailsModel } from 'common/models/page-models/student-details/student-details-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentDetailsWidgetService } from 'common/widget/students/student-details-form-widget.service';
// import { StudentDetailsGridWidgetService } from 'common/widget/students/student-details-widget.service';

@Injectable({
    providedIn: 'root'
})
export class StudentDetailsFormResolver extends FormResolverService<StudentDetailsModel> {
    constructor(
        protected fs: StudentDetailsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);        
    }


    // override initWidget(envelopeType: any, transferData: any): WidgetModel {
    //     const widget = new ();
    //     const metaModel = this.pageService.getMetaModel();
    //     widget.recordPerPage = 10;
    //     widget.searchableFeilds =[];
    //     transferData.assignmentOverviewData = new StudentDetailsGridModel();
    
    //     // transferData.assignmentOverviewMeta = new StudentDetailsMetaModel().getMetaModel();
    //     // this.fs.getFilterOptions(transferData.filterMeta);
    //     widget.transferData = transferData;
    //     return widget;
    // }
}